import React from 'react';
import MyProject from './my-project';

function MyProjectCard() {
    return (
        <div >
            <MyProject />
        </div>
    );
}

export default MyProjectCard;